import { todayLocalISO } from "./utils/dateUtils";
// constants.js

// =============================================================================
// VERİ ŞABLONLARI
// =============================================================================

export const HORIZON_TEMPLATE = {
  no: "",
  sembol: "",
  derinlik_min: 0,
  derinlik_max: "",
  derinlik_arti: false,
  sinir_belirginlik: "",
  sinir_sekil: "",
  ornek_alinamadi: false,
  // Renk alanları güncellendi
  tekstur: "",
  renk_sinif_kuru: "",
  renk_kod_kuru: "",
  renk_sinif_yas: "",
  renk_kod_yas: "",
  struktur_dayaniklilik: "",
  struktur_buyukluk: "",
  struktur_tip: [], // Multi-select olduğu için dizi
  kivam_kuru: "",
  kivam_nemli: "",
  kivam_yas_yapiskanlik: "",
  kivam_yas_plastiklik: "",

  // Kök alanları
  kok_sacak_miktar: "",
  kok_sacak_kalinlik: "",
  kok_kazik_miktar: "",
  kok_kazik_kalinlik: "",

  kirec: "",
  taslilik: "",
  ozel_gorunum: "",
};

// =============================================================================
// FORM BAŞLANGIÇ DURUMU (INITIAL STATE)
// =============================================================================

export const INITIAL_FORM_DATA = {
  // --- KİMLİK & KONUM ---
  is_gecirgenlik_cok_yavas: false, // Yeni: Çok yavaş geçirgenlik tıkı
  is_gecirgenlik_hizli: false, // Yeni: Hızlı geçirgenlik tıkı
  calismanin_adi: "",
  profil_no: "",
  cuval_no: "",
  tanimlayan: "",
  tarih: todayLocalISO(),
  il: "",
  ilce: "", // 'yeri' yerine geldi
  mahalle: "", // Yeni eklendi
  toprak_serisi: "",
  seri_kodu: "",
  profilgrup: "",
  koordinat_x: "",
  koordinat_y: "",
  yukseklik: "",
  iklim: "",
  ort_sicaklik: "",
  ort_yagis: "",

  // --- GÜNCELLENMİŞ RESİM YAPISI ---
  resim_horizon: null, // Tek bir string (Base64)
  resimler_cevre: [], // En fazla 2 adet string içeren dizi
  alinan_ornekler: "",
  // --- FİZYOGRAFYA ---
  fizyografya: "", // DD1...

  // --- ARAZİ & TOPRAK GENEL ---
  ana_materyal: "",
  btg: "",
  kaya_tipi: "",
  mikrorolyef: "",
  arazi_kullanim_sinif: "",
  arazi_kullanim_detay: "",
  urun: "", // Ürün (Açıklama altındaki)
  arazi_aciklama: "", // Arazi kullanımı altındaki açıklama

  tesirli_derinlik: "",
  kok_gel_derinlik: "", // Kök Gel. Elverişli Top. Der.
  kok_gel_eng_faktor: "", // Kök Gel. Eng. Fak. Türü ve Der.

  egim_yuzde: "", // Tek alan (0-2, 2-6 vs.)
  egim_yonu: "", // Bakı
  tabii_drenaj: "",
  // --- TABAN SUYU ---
  taban_suyu_min: "",
  taban_suyu_max: "",
  taban_suyu_belirti: "",
  // --- DRENAJ & SEL ---
  sel_basmasi: "",
  taskin_olasiligi: "",

  // --- EROZYON ---
  erozyon_sekli: "", // Rüzgar / Su (Yüzey, Oluk...)
  su_erozyon_derecesi: "", // Hafif, Orta...
  ruzgar_asinma: "",
  ruzgar_yigilma: "",
  // --- İNSAN ETKİSİ (Çoklu Seçim) ---
  insan_etkisi: [], // ["Sürüm", "Sulama"] şeklinde dizi olacak

  // --- YÜZEY DURUMU & DÜŞÜNCELER ---
  taslilik: "",
  cakillilik: "",
  kayalilik: "",
  yuzey_catlak: "",
  dusunceler: "", // En alttaki büyük not alanı

  tuzluluk: "",
  alkalilik: "",

  // --- HORIZONLAR ---
  horizon_sayisi: 1,
  horizons: [{ ...HORIZON_TEMPLATE, no: 1 }],
};
